var thumbGallery = function(wrapper){
    function swipedetect(param) {
        var touchsurface = param.el,
            startX,
            startY,
            distX,
            distY,
            threshold = 50, //required min distance traveled to be considered swipe
            restraint = 100, // maximum distance allowed at the same time in perpendicular direction
            allowedTime = 300, // maximum time allowed to travel that distance
            elapsedTime,
            startTime,
            onStart = param.onStart || function(){},
            onMove = param.onMove || function(){},
            onEnd = param.onEnd || function(){};

        touchsurface.addEventListener(
            "touchstart",
            function(e) {
                var touchobj = e.changedTouches[0];
                startX = touchobj.pageX;
                startY = touchobj.pageY;
                startTime = new Date().getTime(); // record time when finger first makes contact with surface
                onStart({'startX':startX, 'startY':startY});
                //e.preventDefault();
            },
            false
        );

        touchsurface.addEventListener(
            "touchmove",
            function(e) {
                var touchobj = e.changedTouches[0];
                distX = touchobj.pageX - startX;
                distY = touchobj.pageY - startY;
                onMove({'distX':distX, 'distY':distY});
                e.preventDefault(); // prevent scrolling when inside DIV
            },
            false
        );

        touchsurface.addEventListener(
            "touchend",
            function(e) {
                var touchobj = e.changedTouches[0];
                var swipeData = {'swipe':false};
                distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
                distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
                elapsedTime = new Date().getTime() - startTime; // get time elapsed

                if (elapsedTime <= allowedTime) {
                    // first condition for awipe met
                    if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                        // 2nd condition for horizontal swipe met
                        swipeData.swipe = distX < 0 ? "left" : "right"; // if dist traveled is negative, it indicates left swipe
                    } else if (
                        Math.abs(distY) >= threshold &&
                        Math.abs(distX) <= restraint
                    ) {
                        // 2nd condition for vertical swipe met
                        swipeData.swipe = distY < 0 ? "up" : "down"; // if dist traveled is negative, it indicates up swipe
                    }
                }

                swipeData.distX = distX;
                swipeData.distY = distY;

                onEnd(swipeData);
                //e.preventDefault();
            },
            false
        );
    };

	var frame = wrapper.querySelector('[data-thumbGallery-frame]'),
		navTag = wrapper.querySelector('[data-thumbGallery-nav]'),
		btnLeft = wrapper.querySelector('[data-thumbGallery-btnLeft]'),
		btnRight = wrapper.querySelector('[data-thumbGallery-btnRight]'),
		param = JSON.parse(wrapper.getAttribute('data-param')),
		itemAll = frame.querySelectorAll('[data-thumbGallery-item]'), /* TODO ?? */
		previewAll = navTag ? navTag.querySelectorAll('[data-thumbGallery-preview]') : undefined,
		curInd = 0,
        curNavInd = 0,
		maxInd = itemAll.length - 1,
		stopPlay = false,
		intervarDur = 5000,
        transitionDur = 180,
        isAnimated = false,
        offset = 0, //величина смещения галереи
		init = function(){
		    if(previewAll){
                previewAll.forEach(function(preview, ind){
                    preview.addEventListener('click', function(e){
                        //move(e, ind);
                    });
                });
            }

            frame.addEventListener("transitionend", endTransition, false);

            if(btnLeft){
                btnLeft.addEventListener('click', onLeft);
                btnRight.addEventListener('click', onRight);
			}

            if('ontouchstart' in window){
                swipedetect({
                    el: frame,
                    onStart: startByTouch,
                    onMove: offsetByTouch,
                    onEnd: endByTouch
                });
            }

            checkEdges();
			if(param.autoPlay) stopPlay = setInterval(onRight, intervarDur);

			wrapper.classList.add('js-active');
		},
		abort = function(){
			if(xhr) xhr.abort();
		},
		onLeft = function(e){
            var nextInd = curInd-1;
            var nextNavInd = curNavInd-1;
			if(nextInd < 0) nextInd = maxInd;
			if(nextNavInd < 0) nextNavInd = maxInd;
			move(e, nextInd, nextNavInd);
            sendStat('left');
        },
		onRight = function(e){
			var nextInd = curInd+1;
            var nextNavInd = curNavInd+1;
            if(nextInd > maxInd) nextInd = 0;
            if(nextNavInd > maxInd) nextNavInd = 0;
			move(e, nextInd, nextNavInd);
			sendStat('right');
		},
		move = function(e, nextInd, nextNavInd){
			if(e && stopPlay){//if user clicking everywhere - stop autoplay
                clearInterval(stopPlay);
                stopPlay = false;
			}

            if(isAnimated) return;

            if(previewAll){
                previewAll[curNavInd].classList.remove('js-active');
                previewAll[nextNavInd].classList.add('js-active');
            }

            frame.style.transitionDuration = transitionDur + 'ms';
            isAnimated = true;

            offset = parseInt('-' + frame.getBoundingClientRect().width*nextInd);
            frame.style.transform = 'translate('+ offset +'px, 0px)';

            curNavInd = nextNavInd;
            curInd = nextInd;
		},
        sendStat = function(dir){
		    var stat = param.stat;
		    try{
                gtag('event', stat.name, {
                    'event_category': stat.category,
                    'event_label': dir
                });
            } catch(e){}
        },
        endTransition = function(){
            checkEdges();
            isAnimated = false;
            frame.style.transitionDuration = '0ms';
        },
        startByTouch = function(data){
            if(stopPlay){
                clearInterval(stopPlay);
                stopPlay = false;
            }
        },
        offsetByTouch = function(data){
            if(isAnimated) return;
	        var tempOffset = offset + data.distX;
            frame.style.transform = 'translate('+ tempOffset +'px, 0px)';
        },
        endByTouch = function(data){
	        if(data.swipe == 'left'){
                onRight();
            } else if(data.swipe == 'right'){
	            onLeft();
            }
            else {
                frame.style.transform = 'translate('+ offset +'px, 0px)';
            }
        },
        checkEdges = function(){
	        /*
	        * Проверяем крайние или нет элементы.
	        * Если крайние - доставляем с края другие, чтобы красиво мотать по кругу
	        * */

	        if(curInd==maxInd){
                frame.appendChild(itemAll[0]);
	            curInd--;
                offset = parseInt('-' + frame.getBoundingClientRect().width*curInd);
                frame.style.transform = 'translate('+ offset +'px, 0px)';
                itemAll = frame.querySelectorAll('[data-thumbGallery-item]');
            } else if(curInd==0){
                frame.insertBefore(itemAll[maxInd], itemAll[0]);
                curInd++;
                offset = parseInt('-' + frame.getBoundingClientRect().width*curInd);
                frame.style.transform = 'translate('+ offset +'px, 0px)';
                itemAll = frame.querySelectorAll('[data-thumbGallery-item]');
            }
        },
		destroy = function(){
			abort();

			/* TODO touch */
            if(btnLeft){
                btnLeft.removeEventListener('click', onLeft);
                btnRight.removeEventListener('click', onRight);
            }
		},
		returnObj = {
			destroy: destroy
		};

	//
    if(maxInd > 0) init();
	return returnObj;
};

export {thumbGallery};
